// export const API_ROOT = "https://ccdemo-central-dashboard.herokuapp.com/";
// export const API_ROOT_SHOPIFY = "https://ccdemostaging.herokuapp.com/"
// export const API_ROOT = "http://localhost:3000/";
export const API_ROOT = "https://central.ccdemostore.com/";
export const API_ROOT_SHOPIFY = "https://node.ccdemostore.com/"

export const WIX_API_ROOT = "https://wixapp.ccdemostore.com/ccdemo_wix/index.php/"
export const WP_API_ROOT = "https://wp.ccdemostore.com/dashboard/index.php/"
export const BC_API_ROOT = "https://wixapp.ccdemostore.com/ccdemo_bc/index.php/"
export const PORTAL_API_ROOT = "https://app.ccwholesaleclothing.com/index.php/"
export const BC_EXPORT_API_ROOT = "https://wixapp.ccdemostore.com/ccdemo_bc/dashboard/index.php/"

// all api end points
export const API_END_POINTS = {

  // banner module
  FETCH_MARKETING_BANNERS: "api/banner",
  CREATE_MARKETING_BANNER: "api/banner/create",
  FETCH_SINGLE_MARKETING_BANNER: "api/banner",
  UPDATE_MARKETING_BANNER: "api/banner",
  DELETE_MARKETING_BANNER: "api/banner",
  UPLOAD_BANNER: "api/banner/upload",

  // setting module
  FETCH_SETTING: "api/setting/",
  UPDATE_SETTING: "api/setting",
  
  // login
  LOGIN_URL: "api/authentication/login",
  
  // bigcommerce pricing module
  FETCH_WOCOMMERCES: "api/wocommercepricing/allWocommercePrices",
  CREATE_WOCOMMERCE: "api/wocommercepricing/addWocommercePrice",
  FETCH_SINGLE_WOCOMMERCE: "/api/wocommercepricing/getSingleWocommerce",
  UPDATE_WOCOMMERCE: "/api/wocommercepricing/updateWocommercePrices",
  DELETE_WOCOMMERCE: "/api/wocommercepricing/deleteWocommercePrices",
  
  // shopify pricing module
  FETCH_SHOPIFY: "/api/shopifypricing",
  CREATE_SHOPIFY: "/api/shopifypricing/addPrice",
  FETCH_SINGLE_SHOPIFY: "/api/shopifypricing/getSingleShopify",
  UPDATE_SHOPIFY: "/api/shopifypricing/updateShopifyPrices",
  DELETE_SHOPIFY: "/api/shopifypricing/deleteShopifyPrices",
  
  // wix pricing module
  FETCH_WIX: "/api/wixpricing/allWixPrices",
  FETCH_WIX_WITH_PAGINATION: "/api/wixpricing/",
  CREATE_WIX: "/api/wixpricing/addWixPrice",
  FETCH_SINGLE_WIX: "/api/wixpricing/getSingleWix",
  UPDATE_WIX: "/api/wixpricing/updateWixPrices",
  DELETE_WIX: "/api/wixpricing/deleteWIXPrices",
  
  // cart pricing module
  FETCH_CART: "/api/cartpricing/allCartPrices",
  CREATE_CART: "/api/cartpricing/addCartPrice",
  FETCH_SINGLE_CART: "/api/cartpricing/getSingleCart",
  UPDATE_CART: "/api/cartpricing/updateCartPrices",
  DELETE_CART: "/api/cartpricing/deleteCartPrices",
  
  // setting smtp module
  SMTP_DETAILS_GET: "api/smtp/getSmtp",
  SMTP_DETAILS_UPDATE: "api/smtp/updateSmtp",
  
  // actvity module
  FETCH_ACTIVITY: "api/activity",
  
  // setting popup content
  FETCH_POPUP_CONTENT: "api/popup/getfrontpopup",
  UPDATE_POPUP_CONTENT: "api/popup/updatefrontpopup",

  // shopify category module
  FETCH_CATEGORIES: API_ROOT_SHOPIFY + "admin/api/v1/categories",
  FETCH_SINGLE_CATEGORY : API_ROOT_SHOPIFY + "admin/api/v1/categories/get_category",
  UPDATE_CATEGORIES: API_ROOT_SHOPIFY + "admin/api/v1/categories/change_order",

  // shopify merchant module
  FETCH_SHOPIFY_MERCHANTS: API_ROOT_SHOPIFY + "admin/api/v1/getAllMerchantData",
  SHOPIFY_MERCHANTS_EXPORT: API_ROOT_SHOPIFY + "admin/api/v1/merchantCsv",

  // wix merchant module
  FETCH_WIX_MERCHANTS: WIX_API_ROOT + "admin/MerchantInstallAPI/getAllMerchantData",
  FETCH_SINGLE_WIX_MERCHANT: WIX_API_ROOT + "admin/MerchantInstallAPI/getSingleMerchantData",
  UPDATE_WIX_MERCHANT: WIX_API_ROOT + "admin/MerchantInstallAPI/updateMerchantData",
  WIX_MERCHANTS_EXPORT: WIX_API_ROOT + "admin/ExportMerchants",

  // wp merchant module
  FETCH_WP_MERCHANTS:  WP_API_ROOT + "admin/MerchantInstallAPI/getAllWPMerchantData",
  FETCH_SINGLE_WP_MERCHANT: WP_API_ROOT + "admin/MerchantInstallAPI/getSingleWPMerchantData",
  UPDATE_WP_MERCHANT: WP_API_ROOT + "admin/MerchantInstallAPI/updateWPMerchantData",
  SEND_EMAIL: WP_API_ROOT + "admin/MerchantInstallAPI/sendEmail",
  WP_MERCHANTS_EXPORT: WP_API_ROOT + "admin/Userexport/exportCSV",

  // wix category module
  FETCH_WIX_CATEGORIES: WIX_API_ROOT + "admin/Category2/getsearchdata",
  FETCTH_SINGLE_WIX_CATEGORY: WIX_API_ROOT + "admin/Category2/getSingleCategoryData",
  UPDATE_WIX_CATEGORY: WIX_API_ROOT + "admin/Category2/updateCategorySortOrder",

  // woocomm category module
  FETCH_WOCOMM_CATEGORIES: WP_API_ROOT + "admin/Listing/getCategoryData",
  FETCTH_SINGLE_WOCOMM_CATEGORY: WP_API_ROOT + "admin/Listing/getSingleCategory",
  UPDATE_WOCOMM_CATEGORY: WP_API_ROOT + "admin/Listing/updateCategoryData",

  // bc merchant module
  FETCH_BC_MERCHANTS: BC_API_ROOT + "node_admin/MerchantInstallAPI/getAllMerchantData",
  FETCH_SINGLE_BC_MERCHANT: BC_API_ROOT + "node_admin/MerchantInstallAPI/getSingleMerchantData",
  UPDATE_BC_MERCHANT: BC_API_ROOT + "node_admin/MerchantInstallAPI/updateMerchantData",
  BC_MERCHANTS_EXPORT: BC_EXPORT_API_ROOT + "admin/Userexport/exportCSV",

  // portal merchant module
  FETCH_PORTAL_MERCHANTS:  PORTAL_API_ROOT + "admin/MerchantInstallAPI/getAllMerchantData",
  CREATE_PORTAL_MERCHANTS:  PORTAL_API_ROOT + "admin/MerchantInstallAPI/addNewMerchant",
  FETCH_SINGLE_PORTAL_MERCHANTS:  PORTAL_API_ROOT + "admin/MerchantInstallAPI/getSingleMerchantData",
  UPDATE_PORTAL_MERCHANTS:  PORTAL_API_ROOT + "admin/MerchantInstallAPI/updateMerchantData",
  DELETE_PORTAL_MERCHANTS:  PORTAL_API_ROOT + "admin/MerchantInstallAPI/deleteMerchant",
  PORTAL_MERCHANTS_EXPORT: PORTAL_API_ROOT + "admin/MerchantInstallAPI/exportCSV",

  CHECK_USERNAME_EXIST : PORTAL_API_ROOT + 'admin/MerchantInstallAPI/usernameexist',
  CHECK_EMAIL_EXIST : PORTAL_API_ROOT + 'admin/MerchantInstallAPI/emailexist',

  FETCH_HOME_PAGE_BANNERS : 'api/homebanner',
  UPLOAD_HOME_PAGE_BANNER : 'api/homebanner/upload',
  DELETE_HOME_PAGE_BANNER : 'api/homebanner',
  UPDATE_HOME_PAGE_BANNER_STATUS : 'api/homebanner'
};


